import React from "react";
import MuiAlert, { type AlertProps } from "@mui/material/Alert";
import MuiAlertTitle, { type AlertTitleProps } from "@mui/material/AlertTitle";

export type { AlertProps, AlertTitleProps };

export const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
  return <MuiAlert ref={ref} {...props} />;
});

export function AlertTitle(props: AlertTitleProps) {
  return <MuiAlertTitle {...props} />;
}
